import { Route, BadgeIndianRupee, Landmark, Headset } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

const PILLARS = [
    {
        icon: Route,
        title: "Tailored Itineraries",
        text: "Every route, stay and experience is planned around your pace and interests — never a copy-paste schedule.",
    },
    {
        icon: BadgeIndianRupee,
        title: "Transparent Pricing",
        text: "Clear, itemised quotes with no hidden costs. What you see on the estimate is what you pay.",
    },
    {
        icon: Landmark,
        title: "Handpicked Stays",
        text: "From heritage havelis to lakeside retreats, every property is personally vetted for comfort and character.",
    },
    {
        icon: Headset,
        title: "24/7 On-Ground Support",
        text: "A dedicated helpline travels with you — assistance is one call away, wherever you are in India.",
    },
];

export const WhyUs = () => (
    <section className="py-24 lg:py-32" data-testid="why-us-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeading
                eyebrow="Why Vistaaryatra"
                title="Travel planned by people, not portals"
                description="We are a close-knit team of travel specialists. You always talk to a person who knows your trip — before, during and after you travel."
            />
            <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {PILLARS.map((pillar, i) => (
                    <Reveal key={pillar.title} delay={i * 0.1} className="h-full">
                        <div className="card-frame group flex h-full flex-col p-8 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-30px_rgba(10,25,47,0.45)]">
                            <span className="flex h-12 w-12 items-center justify-center rounded-full border border-brass/40 bg-brass-light/40 text-brass-dark transition-colors duration-300 group-hover:bg-brass group-hover:text-navy">
                                <pillar.icon className="h-5 w-5" />
                            </span>
                            <h3 className="mt-6 font-serif text-xl font-semibold text-navy">{pillar.title}</h3>
                            <p className="mt-3 text-sm leading-relaxed text-steel">{pillar.text}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
